import Swiper from "swiper";
import { Navigation, Scrollbar } from 'swiper/modules';

function sliderBlogMain() {
  new Swiper('.blog__main .swiper', {
    modules: [ Navigation, Scrollbar ],
    spaceBetween: 12,
    slidesPerView: 1,
    grabCursor: true,
    breakpoints: {
      767: {
        slidesPerView: 1,
        spaceBetween: 24,
      },
      1226: {
        slidesPerView: 2,
        spaceBetween: 24,
      }
    },
    navigation: {
      prevEl: '.blog__main .swiper-button-prev',
      nextEl: '.blog__main .swiper-button-next',
    },
    scrollbar: {
      el: '.swiper-scrollbar',
      draggable: true,
    },
  });
}
sliderBlogMain();